import { useMutation } from '@tanstack/react-query';
import { del } from '../libs';

interface Params {
  id: string;
  /**
   * 당일 취소(no-show): CANCELLED
   *
   * 미래일정 삭제: WITHDRAWAL
   */
  status: 'CANCELLED' | 'WITHDRAWAL' | 'NORMAL';
  /**
   * 이후 일정 모두 삭제 시 true, 아니면 false. (default: false)(당일 취소 시에는 applyToAll 불가)
   */
  applyToAll?: boolean;
}

/**
 * 코치 - 직접 일정 삭제
 * @returns
 */
export function useDeleteScheduleCoachMutation() {
  return useMutation(({ id, status, applyToAll = false }: Params) =>
    del(`/schedules/coach/${id}`, { params: { status, applyToAll } })
  );
}
